<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('menu.contact') }}</div>
                <div class="mainBody">
                    <p style="font-size:.3rem;margin-bottom: .1rem;">{{ $t('contact.tips') }}</p>
                    <table width="100%" border="0" cellspacing="4" cellpadding="0">
                        <tbody>
                            <tr>
                                <td>{{ $t('contact.thead.td1') }}</td>
                                <td><span style="opacity: 0;">姓</span>{{ $t('contact.thead.td2') }}<span
                                        style="opacity: 0;">名</span></td>
                                <td>{{ $t('contact.thead.td3') }}</td>
                            </tr>
                            <tr>
                                <td rowspan="2">{{ $t('contact.tbody.line1.job') }}</td>
                                <td>{{ $t('contact.tbody.line1.name') }}</td>
                                <td><a href="tel:18620933880" style="color:#0b8383">186 2093 3880</a></td>
                            </tr>
                            <tr>
                                <td>{{ $t('contact.tbody.line1.name1') }}</td>
                                <td><a href="tel:18100209062" style="color:#0b8383">181 0020 9062</a></td>
                            </tr>
                            <tr>
                                <td>{{ $t('contact.tbody.line2.job') }}</td>
                                <td>{{ $t('contact.tbody.line2.name') }}</td>
                                <td><a href="tel:15112064678" style="color:#0b8383">151 1206 4678</a></td>
                            </tr>
                            <tr>
                                <td>{{ $t('contact.tbody.line3.job') }}</td>
                                <td>{{ $t('contact.tbody.line4.name1') }}</td>
                                <td><a href="tel:13632236190" style="color:#0b8383">136 3223 6190</a></td>
                            </tr>
                            <tr>
                                <td rowspan="2">{{ $t('contact.tbody.line4.job') }}</td>
                                <td>{{ $t('contact.tbody.line4.name') }}</td>
                                <td><a href="tel:18898828831" style="color:#0b8383">188 9882 8831</a></td>
                            </tr>
                            <tr>
                                <td>{{ $t('contact.tbody.line4.name1') }}</td>
                                <td><a href="tel:13632236190" style="color:#0b8383">136 3223 6190</a></td>
                            </tr>
                            <tr>
                                <td>{{ $t('contact.tbody.line5.job') }}</td>
                                <td>{{ $t('contact.tbody.line5.name') }}</td>
                                <td><a href="tel:18100209062" style="color:#0b8383">181 0020 9062</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),

        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/contact']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped>
.en_td {
    line-height: .3rem !important;
    padding: 5px 0 !important;
    font-size: .25rem !important;
}

.zh_td {
    font-size: .25rem !important;
}

table {
    width: 100%;
    width: 6;
    font-size: .3rem;
}

table tr>td {
    font-size: .26rem;
    line-height: .5rem;
    text-align: center;
    color: #0b8383;
}

table tr {
    background: rgba(198, 253, 252, .7);
}

table tr:first-child {
    background: #17aba2;
    color: #fff;
}

table tr:first-child>td {
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/contact.vue